import React from "react";
import { Card } from "../UI";
import { usd, pct } from "./format";

const Kpi = ({ label, value, sub, accent, testid }) => (
  <Card className="!p-4" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
    <div className={`font-display text-2xl font-bold ${accent ? "text-amber-300" : ""}`}>{value}</div>
    {sub && <div className="text-[11px] text-slate-500 mt-0.5">{sub}</div>}
  </Card>
);

const hrs = (h) => (h == null ? "—" : h < 1 ? `${Math.max(1, Math.round(h * 60))} min` : h < 48 ? `${h.toFixed(h < 10 ? 1 : 0)} h` : `${(h / 24).toFixed(1)} d`);

export const AnalyticsKpis = ({ data }) => {
  const f = data.funnel || {}, t = data.time_to_claim || {}, li = data.launch_influence || {};
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="analytics-kpis">
      <Kpi label="Codes in the field" value={f.live || 0} sub={`${f.void || 0} void · ${f.scans || 0} total scans`} testid="kpi-codes" />
      <Kpi label="Claim rate" value={pct(f.claim_rate)} sub={`${f.claimed || 0} claimed of ${f.live || 0}`} testid="kpi-claim-rate" />
      <Kpi label="Redeem rate" value={pct(f.redeem_rate)} sub={`${f.redeemed || 0} redeemed · ${f.reserved || 0} reserved`} testid="kpi-redeem-rate" />
      <Kpi label="Value redeemed" value={usd(f.redeemed_value)} sub={`of ${usd(f.issued_value)} issued`} accent testid="kpi-redeemed-value" />
      <Kpi label="Outstanding liability" value={usd(f.outstanding_value)} sub="unclaimed + claimed balances" testid="kpi-liability" />
      <Kpi label="Time to claim" value={hrs(t.median_hours)} sub={t.samples ? `median · avg ${hrs(t.avg_hours)} · n=${t.samples}` : "no claims yet"} testid="kpi-time-to-claim" />
      <Kpi label="Launches influenced" value={li.launches_paid || 0} sub={`${li.launches_pending || 0} pending approval`} testid="kpi-launches" />
      <Kpi label="Media budget unlocked" value={usd(li.media_budget)} sub={`${usd(li.credit_applied)} credit · ${usd(li.card_revenue)} card`} accent testid="kpi-media-budget" />
    </div>
  );
};
